export const mappingRoleSidebar = {
  ROLE_1: ['users'],
  ROLE_2: ['certificates'],
  ROLE_3: ['certificates'],
  ROLE_4: ['certificates'],
  ROLE_5: ['certificates'],
  ROLE_6: ['arm-certificates']
};
